import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Active from './Active.component'

const mapStateToProps = state => {
  return {
    organisation: state.organisation.active,
    profile: state.session.profile
  }
}

const mapDispatchToProps = () => {return {}}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Active))
